/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_No_Guides_AvailableInputs */



/**
* | output |
* | --- |
* | "No KNP guides available." |
*
* @param {Knp_Lookup_No_Guides_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_no_guides_available = /** @type {((inputs?: Knp_Lookup_No_Guides_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_No_Guides_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun guide KNP disponible.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es sind keine KNP-Führer verfügbar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna guida KNP disponibile.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Путеводители по КНП отсутствуют.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay guías KNP disponibles.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有克鲁格国家公园的导游。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("利用できる KNP ガイドはありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केएनपी के लिए कोई गाइड उपलब्ध नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não há guias disponíveis sobre o Parque Nacional Kruger.")
	return /** @type {LocalizedString} */ ("No KNP guides available.")
});